import getStore from '../store/store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('discardUndoSendOption', () => {
    let optionState = getStore();
    optionState.timeInterval = null;
});
